module.exports = __webpack_public_path__ + "img/check-graphic.c8aa67a7.svg";